module.exports = __webpack_public_path__ + "static/media/pentagram-rose.d7458af6.svg";